import { render, staticRenderFns } from "./logo-field.vue?vue&type=template&id=74437a56&scoped=true"
import script from "./logo-field.vue?vue&type=script&lang=js"
export * from "./logo-field.vue?vue&type=script&lang=js"
import style0 from "./logo-field.vue?vue&type=style&index=0&id=74437a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74437a56",
  null
  
)

export default component.exports